import { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Cookie, X } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('sf_cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('sf_cookie_consent', 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('sf_cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-fade-in-up" data-testid="cookie-consent-banner">
      <div className="max-w-4xl mx-auto bg-navy border border-gold/30 rounded-xl p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4" style={{ boxShadow: '0 -4px 20px rgba(0,0,0,0.15)' }}>
        <Cookie className="w-8 h-8 text-gold flex-shrink-0" />
        <div className="flex-1">
          <p className="text-sm text-white font-body font-medium mb-1">We use cookies to improve your experience</p>
          <p className="text-xs text-white/70 font-body">
            Safe Florida uses essential cookies for authentication and site functionality, and optional cookies for analytics.{' '}
            <Link to="/legal/cookie-policy" className="text-gold underline hover:text-gold/80">Cookie Policy</Link>
          </p>
        </div>
        <div className="flex gap-2 flex-shrink-0">
          <Button onClick={decline} variant="outline" size="sm" className="border-white/30 text-white hover:bg-white/10 font-body text-xs" data-testid="cookie-decline-btn">
            Decline
          </Button>
          <Button onClick={accept} size="sm" className="bg-gold text-navy hover:bg-gold/90 font-body text-xs font-bold" data-testid="cookie-accept-btn">
            Accept All
          </Button>
        </div>
        <button onClick={decline} className="absolute top-2 right-2 sm:static text-white/50 hover:text-white">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
